import axios from "axios"
import https from "https"

// eslint-disable-next-line
export default () => {
  return axios.create({
    baseURL: base_url,
    httpsAgent: new https.Agent({  
      rejectUnauthorized: false
    })
  })
}

export const base_url = `https://hcvf.citorus.ru:8889/`;